import axios from 'axios';
import config from '../config';
import { showError } from '../utils';

import { store } from '../store';

// Generic network call function to handle common API request patterns
function networkCall({ method, url, headers, params, data, ...extraOptions }) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getWaterLogDetails(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/water-tracking`,
    headers,
  });
}

export function removeWater(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/water-tracking/intake/remove`,
    headers,
    data: null,
  });
}

export function addWater(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/water-tracking/intake/add`,
    headers,
    data: null,
  });
}

export function deleteWaterLogById(authToken, id) {
  const headers = {
    authorization: authToken,
  };

  const data = {
    intakeId: id,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/water-tracking/intake/remove`,
    headers,
    data,
  });
}

export function updateDefaults(authToken, goal, vesselKey) {
  const headers = {
    authorization: authToken,
  };

  const data = {
    goal,
    vesselKey,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/water-tracking/change-defaults`,
    headers,
    data,
  });
}
